import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import './style.scss';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import PublicPageLayout from '../../../layout/PublicPageLayout';
import PageHeader from '../../../layout/PageHeader';
import PageMainContent from '../../../layout/PageMainContent';
import { LOGO_SIZE } from '../../../ui/Logo';
import Loader from '../../../ui/Loader';
import { formatLangCode } from '../../../helpers';
import { getPublicFaqTree } from '../../../api/public/faq';
import PublicFaqList from '../../../modules/PublicFaqList';
// Phase 7 Plan 07-03 Task 1 — PublicFaqPage shell.
//
// CONTEXT D-01: Reuse `PublicPageLayout` verbatim (footer + active-game modal
//   side-effect). No fork, no `skipActiveGameCheck` prop.
// CONTEXT D-11/D-13: Active locale is a render-time function of the active
//   i18n language via `formatLangCode`. Fetch is on-mount only (NOT keyed on
//   the active locale) — the API response already contains all three locales,
//   so swapping language does not trigger a refetch.
// CONTEXT D-12: Empty-state ("post-filter visible categories array is empty")
//   is owned by `PublicFaqList` so the rule lives next to the filter; the page
//   passes `emptyMessage={t('faq.empty')}` down.
// CONTEXT D-15 / Phase 5 D-13: trust boundary for RTE HTML is server-side;
//   the answer body's `dangerouslySetInnerHTML` lives in `FaqAccordionRow` —
//   this page does NOT add a client sanitizer dependency or transform payload.
// SPEC R-8: error state is `t('faq.error')` with NO retry button.
const PublicFaqPage = () => {
    const { t, i18n } = useTranslation();
    const [tree, setTree] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(false);
    useEffect(() => {
        let cancelled = false;
        const fetchTree = async () => {
            setIsLoading(true);
            setError(false);
            try {
                const result = await getPublicFaqTree();
                if (!cancelled) {
                    setTree(result);
                }
            }
            catch {
                if (!cancelled) {
                    setError(true);
                }
            }
            finally {
                if (!cancelled) {
                    setIsLoading(false);
                }
            }
        };
        fetchTree();
        return () => {
            cancelled = true;
        };
    }, []);
    const activeLang = formatLangCode(i18n.language);
    return (_jsx(PublicPageLayout, { children: _jsxs("div", { className: "page-content-wrapper faq-page", children: [_jsx(PageHeader, { logoSize: LOGO_SIZE.FULL, logoLink: "/" }), _jsx(PageMainContent, { children: _jsxs("div", { className: "faq-content", children: [_jsx("h1", { className: "faq-page-title", children: t('faq.title') }), isLoading && (_jsx("div", { className: "faq-status-wrapper", children: _jsx(Loader, {}) })), !isLoading && error && (_jsx("p", { className: "faq-status-wrapper faq-error", children: t('faq.error') })), !isLoading && !error && tree && (_jsx(PublicFaqList, { tree: tree, activeLang: activeLang, emptyMessage: t('faq.empty') }))] }) })] }) }));
};
export default PublicFaqPage;
